module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Outgoing-call-952a62b210ee8990d01fa56fd67eb5fa.svg";